module.exports = __webpack_public_path__ + "static/media/arabic-flag.ad66a9ed.svg";